import _ from 'lodash';

export const isMatchPattern = ({ uri, compareUri, method, compareMethod }) => {
  const splitted = _.trim(uri, '/').split('/');

  const splittedPattern = _.trim(compareUri, '/').split('/');

  if (splitted.length !== splittedPattern.length) return false;

  const isVariablePattern = /^{.*}$/;

  const regexList = splittedPattern.map((path) => {
    if (isVariablePattern.test(path)) return new RegExp('.', 'g');

    return new RegExp(`^${path}$`, 'g');
  });

  const isMatched = regexList.every((regex, index) => regex.test(splitted[index]));

  return method && compareMethod ? isMatched && method.toUpperCase() === compareMethod.toUpperCase() : isMatched;
};

export const isDeniedAction = (actionPatterns, deniedPatterns) => {
  if (_.isEmpty(actionPatterns) || _.isEmpty(deniedPatterns) || !_.isArray(actionPatterns) || !_.isArray(deniedPatterns)) return false;

  return actionPatterns.some((pattern) =>
    deniedPatterns.some((deniedPattern) =>
      isMatchPattern({ uri: pattern.path, compareUri: deniedPattern.path, method: pattern.method, compareMethod: deniedPattern.method }),
    ),
  );
};

export const containsString = (keyword, strData, regexOpt) => {
  const str = _.toString(strData);
  const key = _.toString(keyword);

  if (regexOpt && regexOpt.includes('i')) {
    // Case-insensitive search
    return str.toLowerCase().includes(key.toLowerCase());
  }

  // Case-sensitive search
  return str.includes(key);
};

export const searchInObject = (o, k, regexOpt, fields) => {
  if (fields && fields.length > 0) {
    for (let i = 0; i < fields.length; i++) {
      const v = _.get(o, fields[i]);
      if (v && containsString(k, v, regexOpt)) {
        return true;
      }
    }
  } else {
    for (let field in o) {
      if (!o.hasOwnProperty(field)) continue;
      if (o[field] && containsString(k, o[field], regexOpt)) {
        return true;
      }
    }
  }

  return false;
};
